// /* jshint ignore:start */
// (function () {
//     'use strict';
//     angular.module('HeroPRO')
//         .service('geoStateCacheService',

/* @ngInject */
export default function GEOStateCacheService($stateParams) {
    let _geoState = null;
    const urlGeoState = '';

    this.setGeoStates = function (geoState) {
        _geoState = geoState;
    };

    this.getGeoStates = function () {
        return _geoState;
    };

    this.getGeoStateObject = function (geoStateCode) {
        const gStates = this.getGeoStates();
        for (let i = 0; i < gStates.length; i++) {
            if (geoStateCode === gStates[i].StateAbbreviation) {
                return gStates[i];
            }
        }
    };

    this.getCurrentStateObject = function () {
        return this.getGeoStateObject($stateParams.GeoState);
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/services/geoStateCacheService.js